import Vue from 'vue';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';

Vue.use(VueApollo);

const apolloClient = new ApolloClient({
  uri: `${window.BASE_URL}/graphql`,
  // cache: new InMemoryCache(),
  request: (operation) => {
    // Get the cookie from document.cookie
    const cookie = document.cookie;
    
    // Set the headers for the operation
    operation.setContext({
      headers: {
        Cookie: cookie,
      },
      credentials: 'include' // This ensures cookies are sent with the request
    });
  }
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

export default apolloProvider;
